<template>

    <div class="ultim_wrapper">
        <div class="ultim_model" >
            <p>Le modèle ULTIM intègre des rôles complémentaires pour assurer le succès d’une équipe</p>
            <!--<div class="ultim_explains">
                <div>{{scores_data.ultim_u.def_text.explain}}</div>
                <div>{{scores_data.ultim_l.def_text.explain}}</div>
                <div>{{scores_data.ultim_t.def_text.explain}}</div>
                <div>{{scores_data.ultim_i.def_text.explain}}</div>
                <div>{{scores_data.ultim_m.def_text.explain}}</div>
            </div>-->
        </div>
        
        <div class="ultim_scores_container container">
            <UltimScore :score_data="scores_data.ultim_u" />
            <UltimScore :score_data="scores_data.ultim_l" />
            <UltimScore :score_data="scores_data.ultim_t" />
            <UltimScore :score_data="scores_data.ultim_i" />
            <UltimScore :score_data="scores_data.ultim_m" />
        </div>
    </div>


</template>

<script>
import UltimScore from './ultimScore2'


export default {
    name: 'UltimScores',
    props: ['scores_data'],
    components: {
        UltimScore
    },
    mounted() {},
    data(){
        return {}
    },
    computed: {
        labels(){
            
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
    .ultim_scores_container{
        max-width: 1000px;
        padding-top: 0px;
        padding-bottom: 80px;
    }
    .ultim_model{
        text-align: center;
        padding: 50px 0 0;
        p{
            font-size: 1.35rem;
            margin-bottom: 18px;
            
        }
        .ultim_explains{
            font-size: 1.1rem;
            font-weight: 500;
        }
    }
</style>
